import { post } from 'libs/GrebbCommerceAPI/util';

export default async (basketId, giftCert, amount = null) => {
    // If we have passed in an amount, the user has selected the Flexible
    // gift certificate. So then we use the endpoint for that.
    if (amount) {
        return await post(`/basket/${basketId}/gift-certificate/${giftCert}/amount/${amount}`, {});
    }

    // If no amount is passed, we send only the gift-cert "id"
    return await post(`/basket/${basketId}/gift-certificate/${giftCert}`, {});
};
